import React from 'react';
import { withTranslation } from 'react-i18next';
import { SearchBar, SearchBlockStyle } from '../../../../styles';
import { ClickableArea } from '../../../../styles/commonStyle';
import { searchIcon } from '../Search/Icons/SearchIcon';
import { searchCloseIcon } from '../Search/Icons/SearchCloseIcon';
import { connect } from 'react-redux';
import { Title } from '../Title';
import {
  IconButton,
  // Input,
} from 'wix-ui-tpa';
import triggerEvent from '../../../../../../services/bi/biSiteLogger';
import biData from '../../../../../../services/bi/biEvents.json';

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      questionsToShow: [],
      expandSearch: false,
      heightHeader: 'auto',
      searchValue: '',
      searchText: '',
    };

    this.searchInput = React.createRef();
    this.searchAndTitleContainer = React.createRef();
    this.closeSearchOnBlur = this.closeSearchOnBlur.bind(this);
    this.openSearch = this.openSearch.bind(this);
    this.closeSearch = this.closeSearch.bind(this);
    this.canCloseSearch = this.canCloseSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.keyPress = this.keyPress.bind(this);
  }

  handleChange(e) {
    const searchText = e.target.value;
    this.setState({ searchText });
    this.props.onChangeSearchValue(searchText);
    triggerEvent(biData.SEARCH_QUESTION);
  }

  keyPress(e) {
    if (e.key === 'Enter') {
      this.handleChange(e);
    }
  }

  openSearch(event) {
    try {
      event.stopPropagation();
      event.preventDefault();
    } catch (err) {}

    this.setState(
      {
        expandSearch: true,
        heightHeader: this.searchAndTitleContainer.current.clientHeight + 'px',
      },
      () => {
        this.searchInput.current.focus();
      },
    );
  }

  closeSearch(event) {
    try {
      event.stopPropagation();
      event.preventDefault();
      this.searchInput.current.value = '';
    } catch (err) {
      // console.log("closeSearch err: ",err);
    }

    this.setState({ expandSearch: false, searchText: '' });
    this.setState({ heightHeader: 'auto' });
    this.props.onChangeSearchValue('');
    return false;
  }

  closeSearchOnBlur() {
    if (this.state.searchText === '' && this.canCloseSearch()) {
      this.setState({ heightHeader: 'auto', expandSearch: false });
      this.props.onChangeSearchValue('');
    }
  }

  canCloseSearch() {
    const wDimensions = this.props.getWindowDimensions();
    return wDimensions.w > 455;
  }

  render() {
    const { settings, t, design, styleParams, i18n } = this.props;
    return (
      <>
        <SearchBlockStyle
          design={design}
          styleParams={styleParams}
          className={
            'faq-header flexbox-item ' +
            (settings.searchBar.show === false && settings.title.show === false
              ? 'hidden-header'
              : '') +
            ' layout-' +
            settings.layout
          }
        >
          <div
            ref={this.searchAndTitleContainer}
            className={
              (!this.canCloseSearch() && settings.searchBar.show === false
                ? ' hidden '
                : ' search-and-title ') +
              (this.state.expandSearch ? ' active ' : '') +
              (settings.title.show ? ' justify-content' : '')
            }
            style={{ height: this.state.heightHeader }}
          >
            {settings.title.show === true && (
              <Title
                text={t(settings.title.text)}
                textAlign={settings.title.alignment}
              />
            )}
            <SearchBar
              role="search"
              className={
                'search-box ' +
                (this.state.expandSearch ? 'active ' : 'not-active') +
                (!this.canCloseSearch() && !this.state.expandSearch
                  ? 'border-bottom'
                  : '')
              }
              style={{
                display: settings.searchBar.show ? 'block' : 'none',
              }}
            >
              <input
                style={!this.state.expandSearch ? { visibility: 'hidden' } : {}}
                className={
                  'search-input ' +
                  (this.state.expandSearch ? 'active' : 'not-active')
                }
                aria-label={t('search.input.aria.label')}
                maxLength="50"
                ref={this.searchInput}
                onKeyPress={this.keyPress}
                onChange={this.handleChange}
                onBlur={(event) => this.closeSearchOnBlur(event)}
                placeholder={t(settings.searchBar.text)}
              />
              <ClickableArea
                className={this.state.expandSearch ? 'hidden' : ''}
                onClick={(event) => this.openSearch(event)}
              />
              <IconButton
                id="searchIconButton"
                aria-label={t('search.btn.aria.label')}
                tabIndex={this.state.expandSearch ? '-1' : '0'}
                icon={searchIcon({})}
                className="search-icon"
                onClick={(event) => {
                  this.openSearch(event);
                }}
                onKeyPress={() => {
                  this.setState({ expandSearch: true });
                }}
              />

              <IconButton
                id="closeSearch"
                aria-label={t('clearSearch.btn.aria.label')}
                icon={searchCloseIcon({})}
                className="search-close-icon"
                style={{
                  display: this.state.expandSearch ? 'block' : 'none',
                }}
                onKeyPress={() => {
                  document.getElementById('searchIconButton').focus();
                }}
                onClick={(event) => this.closeSearch(event)}
              />
            </SearchBar>
          </div>
        </SearchBlockStyle>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Header));
